import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ListOption } from '../../common/interfaces';

@Component({
    selector: 'list-option-dialog',
    templateUrl: './list-option-dialog.component.html',
    styleUrls: ['./list-option-dialog.component.css'],
    standalone: false
})
export class ListOptionDialogComponent {
  title = '';
  public selectedOption: string;

  constructor(public dialogRef: MatDialogRef<ListOptionDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: ListOptionDialogModel) {
    const selected = data.listOptions.find((type) => type.selected === true);
    this.selectedOption = selected ? selected.value : data.listOptions[0].value;
    this.title = data.title;
  }

  onConfirm(): void {
    const dialogResult: ListOptionDialogResult = { result: true, value: this.selectedOption };
    this.dialogRef.close(dialogResult);
  }

  onCancel(): void {
    const dialogResult: ListOptionDialogResult = { result: false };
    this.dialogRef.close(dialogResult);
  }
}

export class ListOptionDialogModel {
  constructor(public listOptions: ListOption[], public title: string) {
  }
}

export interface ListOptionDialogResult {
  result: boolean;
  value?: string;
}
